module.exports = __webpack_public_path__ + "assets/img/benefit-5.62c51194.svg";